mutation AddEntityToAudience($audienceId: ID!, $entityId: ID!) {
    addEntityToAudience(input: {audienceId: $audienceId, entityId: $entityId}) {
        audienceMembers {
            id
        }
    }
}
